
  import { Watch,Mixins,Component, Vue, ProvideReactive, Ref } from "vue-property-decorator";
  
  import { presCategoryTypeList, getPresCategoryList } from "@/api/prescriptionDb"
  
  import { cloneDeep } from "lodash";

  import WsProductSetting from "./components/settingTable.vue";
  import { wsSymptom, wsSymptomProductList } from "@/api/wsProduct";
  
  @Component({
      inject: [],
      components: {
        WsProductSetting,
      }
  })
  export default class PrescriptionProductList extends Vue {

    symptomType = "1";


    @ProvideReactive()
    storeId = this.$route.query?.storeId;

    storeName = decodeURIComponent(this.$route.query?.storeName as string || "");

    physiqueSymptoms = [];
    tongueSymptoms = [];

    @ProvideReactive()
    symptomId = "";

    mounted() {
        this.wsSymptom();
    }

    get symptomList () {
        return this.symptomType == '1' ? this.physiqueSymptoms : this.tongueSymptoms;
    }

    wsSymptom() {
        wsSymptom({}).then((res) => {
            const { physiqueSymptoms, tongueSymptoms } = res.data ?? {};
            this.physiqueSymptoms = physiqueSymptoms;
            this.tongueSymptoms = tongueSymptoms;
            this.changeTab();
        })
    }

    changeSymptom(item) {
        this.symptomId = item.id;
    }

    @Watch("symptomType", { immediate: true })
    changeTab() {
        this.symptomId = this.symptomList?.[0]?.id;
    }

  }
  